<script>
  import Description from "../../../components/shared/Description.svelte";
  import { integrationStore } from "../../../stores";

  $: learnMoreLink = $integrationStore.getLearnMoreLink("generalSettings");

  $: description = {
    title: "General Settings",
    description:
      "Customize optional settings to tailor your SourceWhale experience to specific workflows.",
    learnMoreLink,
  };
</script>

<Description {...description} />
